/**
 * Created by Andrey Popov on 9/22/25.
 */

const LevelContentCopyHandler = function () { };

LevelContentCopyHandler.isContextApplicable = function () {
    return cleverapps.environment.isAdministratorScene()
        && cleverapps.config.type === "tile3";
};

LevelContentCopyHandler.prototype.isApplicable = function () {
    const activeLevel = cleverapps.administrator
        && cleverapps.administrator.adminLevels
        && cleverapps.administrator.adminLevels.getActive();

    return LevelContentCopyHandler.isContextApplicable() && activeLevel;
};

LevelContentCopyHandler.prototype.copy = function () {
    const meta = { type: "LevelContent", gameName: cleverapps.config.name };
    const data = cleverapps.clone(cleverapps.administrator.adminLevels.getActive().getContent(), true);
    return JSON.stringify({
        meta,
        data
    }, null, 4);
};

ClipboardService.REGISTERED_COPY_HANDLERS.push(LevelContentCopyHandler);